"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDataTable = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const gettext_1 = require("@integro/gettext");
require("./styles.scss");
const header_1 = require("./header");
const body_1 = require("./body");
const column_1 = require("./column");
const table_html_1 = __importDefault(require("./table.html"));
const constants = __importStar(require("./constants"));
const model_1 = require("./model");
const log = (0, debug_1.default)('itp:ui:components:datatable');
const NEW_ROW_PREFIX = '$$newrow$$_';
let ItpDataTable = class ItpDataTable extends vue_1.default {
    model;
    cols;
    rows;
    currentPage;
    value;
    groups;
    groupKeyField;
    messages;
    columns;
    hidden;
    paging;
    editable;
    prependNewRow;
    compact;
    rowKeyField;
    useIndexAsRowKey;
    showHeader;
    rowHeader;
    rowSelection;
    tableId;
    noPersistState;
    title;
    tableClass;
    rowClassName;
    rowTemplate;
    variant;
    rowStyle;
    cellClass;
    cellStyle;
    headerMode;
    headerCellClassName;
    headerCellStyle;
    wrapHeaderText;
    lang;
    noCreateRow;
    noDeleteRow;
    noConfirmDeleteRow;
    noExpandableRowDetails;
    rowDetailsMode;
    isRowEditable;
    isRowDeletable;
    size;
    sortField;
    sortMode;
    sortOrder;
    sortable;
    globs;
    fillEmptyRowSpace;
    columnHeaderStyle;
    footerTotals;
    onRowsChanged(newValue) {
        this.model.updateRows(newValue);
    }
    onGroupsChanged(newValue) {
        this.model.updateGroups(newValue);
    }
    onColumnsChanged(newValue) {
        this.cols = this.getColumns();
        this.model.options.columns = this.cols;
    }
    onEditableChanged(newValue) {
        this.cols = this.getColumns();
        this.model.options.columns = this.cols;
        this.model.options.editable = newValue;
    }
    onPagingChanged(newValue) {
        if (newValue) {
            this.model.pager.enable();
        }
        else {
            this.model.pager.disable();
        }
    }
    onPageSizeChanged(newValue) {
        this.model.pager.setPageSize(newValue);
    }
    onCurrentPageChanged(newValue) {
        this.model.pager.setCurrentPage(newValue);
    }
    onNoCreateRowChanged(newValue) {
        this.model.options.canCreateRow = !newValue;
    }
    onGlobsChanged(newValue) {
        this.model.options.globs = newValue || {};
    }
    onFillEmptyRowSpaceChanged(newValue) {
        this.model.options.fillEmptyRowSpace = newValue;
    }
    onRowTemplateChanged(newValue) {
        this.model.options.rowTemplate = newValue;
    }
    onRowHeaderChanged(newValue) {
        this.model.options.rowHeader = newValue;
    }
    onColumnHeaderStyleChanged(newValue) {
        this.model.options.columnHeaderStyle = newValue;
    }
    data() {
        const cols = this.getColumns();
        const model = new model_1.TableModel({
            columns: cols,
            groups: this.groups,
            groupKeyField: this.groupKeyField,
            tableId: this.tableId,
            rowKeyField: this.rowKeyField,
            useIndexAsRowKey: this.useIndexAsRowKey,
            messages: this.messages,
            rows: this.value,
            paging: this.paging,
            lang: this.lang,
            rowDetailsMode: this.rowDetailsMode,
            headerMode: this.headerMode,
            editable: this.editable,
            checkRowAction: this.checkRowAction,
            sortable: this.sortable,
            canCreateRow: !this.noCreateRow,
            globs: this.globs || {},
            fillEmptyRowSpace: this.fillEmptyRowSpace,
            rowTemplate: this.rowTemplate,
            rowHeader: this.rowHeader,
            rowSelection: this.rowSelection,
            columnHeaderStyle: this.columnHeaderStyle,
            cellClass: this.cellClass,
            noDeleteRow: this.noDeleteRow,
            noConfirmDeleteRow: this.noConfirmDeleteRow,
            footerTotals: this.footerTotals
        }, this);
        return {
            ...constants,
            model,
            currentPage: 1,
            cols,
            editingRowKey: null,
            editingRow: null,
            editingRowBackup: null,
            editingRowStatus: null,
            pageSize: 10,
            pageSizeOptions: [10, 25, 50, 100, 200],
            resizeElement: null
        };
    }
    mounted() {
        log('[%s] mounted: %o', this.tableId, this.model);
        this.model.componentMounted = true;
    }
    get hasRowDetails() {
        return ((!this.noExpandableRowDetails && !!this.$slots.rowDetails) ||
            !!this.$scopedSlots.rowDetails);
    }
    get className() {
        const result = ['itp-datatable'];
        if (this.variant) {
            result.push(`variant-${this.variant}`);
        }
        return result;
    }
    get tableClassName() {
        const result = ['table'];
        if (this.tableClass) {
            result.push(this.tableClass);
        }
        if (this.variant) {
            result.push(`variant-${this.variant}`);
        }
        return result;
    }
    get allColumnsCount() {
        if (this.cols) {
            return this.editable ? this.cols.length + 1 : this.cols.length;
        }
        return 0;
    }
    get isHeaderVisible() {
        return this.showHeader !== false && this.model.headerIsVisible;
    }
    get msgPagingInfo() {
        const pager = this.model.pager;
        return (0, gettext_1.pgettext)('DataTable', 'Showing %(pageStartPos)s to %(pageEndPos)s of %(totalNumberOfItems)s entries.', undefined, {
            pageStartPos: pager.currentPage.startPos,
            pageEndPos: pager.currentPage.endPos,
            totalNumberOfItems: pager.totalSize
        });
    }
    onKeyUp(ev) {
        if (ev.code === 'KeyN' && ev.altKey) {
            ev.stopPropagation();
            ev.preventDefault();
            this.model.addNewRow();
            return false;
        }
    }
    getColumns() {
        let result = [];
        if (this.rowHeader) {
            result.push(new column_1.ColumnDefinition(this, {
                name: constants.COLNAME_ROW_HEADER,
                type: 'system',
                width: '20px',
                systemColumn: true,
                frozen: true,
                sticky: 'left',
                attrs: {}
            }));
        }
        if (this.rowSelection) {
            result.push(new column_1.ColumnDefinition(this, {
                name: constants.COLNAME_ROW_SELECTOR,
                type: 'system',
                width: '20px',
                systemColumn: true,
                frozen: true,
                sticky: 'left',
                attrs: {}
            }));
        }
        if (this.columns) {
            result = result.concat(_.chain(this.columns)
                .filter(col => !col.disabled)
                .map(col => new column_1.ColumnDefinition(this, col))
                .value());
        }
        if (this.$slots.default) {
            for (let col of (0, column_1.getColumnsFromVNodes)(this.$slots.default)) {
                let target = _.find(result, { name: col.name });
                if (target) {
                    target.mergeConfigIn(col);
                    continue;
                }
                result.push(new column_1.ColumnDefinition(this, col));
            }
        }
        if (this.fillEmptyRowSpace) {
            result.push(new column_1.ColumnDefinition(this, {
                name: constants.COLNAME_FILL_SPACE,
                type: 'system',
                systemColumn: true,
                attrs: {}
            }));
        }
        result.push(new column_1.ColumnDefinition(this, {
            name: constants.COLNAME_ROW_MENU,
            type: 'system',
            systemColumn: true,
            frozen: true,
            width: '80px',
            sticky: 'right',
            attrs: {}
        }));
        log('columns: %o', result);
        return result;
    }
    checkRowAction(action, row) {
        if (action === 'edit' && _.isFunction(this.isRowEditable)) {
            return this.isRowEditable(row.getData());
        }
        if (action === 'delete' && _.isFunction(this.isRowDeletable)) {
            return this.isRowDeletable(row.getData());
        }
        return true;
    }
    async callListeners(method, ...args) {
        let listener = this.$listeners[method] || this.$attrs[method];
        if (_.isFunction(listener)) {
            log('calling listener %s: %o (%o)', method, args, listener);
            listener(...args);
            return true;
        }
        return false;
    }
};
exports.ItpDataTable = ItpDataTable;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Array)
], ItpDataTable.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", Array)
], ItpDataTable.prototype, "groups", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'group_id', type: String }),
    __metadata("design:type", String)
], ItpDataTable.prototype, "groupKeyField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object }),
    __metadata("design:type", Object)
], ItpDataTable.prototype, "messages", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Array)
], ItpDataTable.prototype, "columns", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "hidden", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "paging", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "editable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "prependNewRow", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "compact", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'id' }),
    __metadata("design:type", String)
], ItpDataTable.prototype, "rowKeyField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "useIndexAsRowKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "showHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "rowHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "rowSelection", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "tableId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "noPersistState", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", Object)
], ItpDataTable.prototype, "tableClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpDataTable.prototype, "rowClassName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpDataTable.prototype, "rowTemplate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "variant", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "rowStyle", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpDataTable.prototype, "cellClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "cellStyle", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null }),
    __metadata("design:type", String)
], ItpDataTable.prototype, "headerMode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "headerCellClassName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "headerCellStyle", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "wrapHeaderText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "lang", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "noCreateRow", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "noDeleteRow", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "noConfirmDeleteRow", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "noExpandableRowDetails", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null }),
    __metadata("design:type", String)
], ItpDataTable.prototype, "rowDetailsMode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Function)
], ItpDataTable.prototype, "isRowEditable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Function)
], ItpDataTable.prototype, "isRowDeletable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'sm' }),
    __metadata("design:type", String)
], ItpDataTable.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "sortField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTable.prototype, "sortMode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Number)
], ItpDataTable.prototype, "sortOrder", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "sortable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null }),
    __metadata("design:type", Object)
], ItpDataTable.prototype, "globs", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "fillEmptyRowSpace", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'tableHeader' }),
    __metadata("design:type", String)
], ItpDataTable.prototype, "columnHeaderStyle", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false }),
    __metadata("design:type", Boolean)
], ItpDataTable.prototype, "footerTotals", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onRowsChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('groups'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onGroupsChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('columns'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onColumnsChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('editable'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onEditableChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('paging'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onPagingChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('pageSize'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onPageSizeChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentPage'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onCurrentPageChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('noCreateRow'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onNoCreateRowChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('globs'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onGlobsChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('fillEmptyRowSpace'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onFillEmptyRowSpaceChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('rowTemplate'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onRowTemplateChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('rowHeader'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onRowHeaderChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('columnHeaderStyle'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ItpDataTable.prototype, "onColumnHeaderStyleChanged", null);
exports.ItpDataTable = ItpDataTable = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: table_html_1.default,
        components: { ItpDataTableColumn: column_1.ItpDataTableColumn, ItpDataTableHeader: header_1.ItpDataTableHeader, ItpDataTableBody: body_1.ItpDataTableBody },
        provide() {
            return {
                table: this,
                model: this.model
            };
        }
    })
], ItpDataTable);
//# sourceMappingURL=table.js.map